import React from 'react';
import { SpecialistCard } from '../../../../../../components/SpecialistCard';
import { formatDatetime1 } from '../../../../../../utils/dates';
import styled from 'styled-components';

export const SpecialistCardWrapper = styled.div`
  position: relative;
`;

export type ResourceSlot = {
  slotResourceID: string;
  productName: string;
  date?: Date;
  showCheck?: boolean;
  professionalName: string;
};

export const ProfessionalCard = ({ date, productName, slotResourceID, professionalName, showCheck }: ResourceSlot) => {
  return (
    <>
      <SpecialistCardWrapper>
        <SpecialistCard
          imgSrc={slotResourceID ? `https://aps-digital.s3.amazonaws.com/profissionais/${slotResourceID}.jpg` : ''}
          title={productName}
          description={professionalName}
          otherInfo={date ? formatDatetime1(date) : ''}
          showCheck={showCheck}
        />
      </SpecialistCardWrapper>
    </>
  );
};
